module.exports = __webpack_public_path__ + "img/qr-code-dummy.7c0ed4d0.svg";